import React,{useState} from 'react';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';

export default function MailerForm() {
    const [email, setemail]= useState('');
    const [message, setMessage]= useState('');
    const sendMail = (e) => {
        e.preventDefault();
    
        const form = e.target;
        

        console.log(form);
        
        
    }
    const handleEmailChange = (e) => {
        this.setState({email: e.target.value});
        console.log(e.target.value);
    }
    const handleMessageChange = (e) => {
        this.setState({message: e.target.value});
        console.log(e.target.value);
    }
    
    return(
        <>
        <Form onSubmit={sendMail}>
        <Form.Group controlId="formBasicEmail">
            <Form.Label>Email address</Form.Label>
            <Form.Control type="email" name="email" placeholder="Enter email" onChange={()=>this.handleEmailChange()} />
            <Form.Text className="text-muted">
            We'll never share your email with anyone else.
            </Form.Text>
        </Form.Group>
        <Form.Group controlId="exampleForm.ControlTextarea1">
            <Form.Label>Example textarea</Form.Label>
            <Form.Control as="textarea" name="message" rows="3" onChange={()=>this.handleMessageChange()} />
        </Form.Group>
        <Button variant="primary" type="submit">
            Submit
        </Button>
        </Form>
            
        </>
    )
}